<div  class="row">
  <div class="input-group">
    <span class="input-group-addon">
      <span class="armx-search" aria-hidden="true">
      </span>
    </span>
    <input type="text" class="form-control" [placeholder]="'pages.outletSelection.entitySelection.searchPlaceholder' | translate" (keyup)="search($event)" [(ngModel)]="searchTerm" />
  </div>
</div>
<div *ngIf="companies.length > 0" class="row">
  <div *ngFor="let company of companies; let i = index" class="col-md-3 center ">
    <div class="entity-border">
      <div class="center entity-main-img entity-img{{company.backgroundItem}}">
        <h2 class="entity-txt">{{company.BranchCompanyName}}</h2>
      </div>
      <h3>{{company.BranchCompanyCountryCode}}</h3>
      <h5><span>{{company.BranchCompanyCountryName}}</span></h5>
      <button (click)="setCompany(company)" class="btn btn-primary width130p" style="margin-top:35%;">{{ 'pages.outletSelection.entitySelection.go' | translate }}</button>
    </div>
  </div>
</div>
<div *ngIf="companies.length == 0" class="row" style="text-align: center;">
  <h3>{{ 'pages.outletSelection.entitySelection.locationNotFound' | translate }}</h3>
</div>
<!--<nav class="nav-pagination">
  <ul class="pagination">
    <li><button class="btn"><span class="armx-icon armx-left-dir"></span></button></li>
    <li *ngFor="let company of companies; let i = index">
      <button class="btn active" href="#">{{ i+1
        }}</button>
        </li>
        <li><button class="btn"><span class="armx-icon armx-right-dir"></span></button></li>
        </ul>
        </nav>-->
